import React, { useContext, useEffect, useState } from 'react'
import styles from './BasicInformation.module.css'
import { FormTitle } from '../../../../Common/FormTitle'
import { NextButton } from '../../../../Common/CtaButton/NextButton'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import { StepContext } from '../../../StepContainer'
import { checkFormValidity, validateForm } from '../../FullName/validate'
import { NameFormField } from './NameFormField'
import { NameFormErrors, NameFormTouched } from '../../FullName/types'

export const JobSeekerNameOnly = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const [lastName, setLastName] = useState(formState.lastName || '')
    const [firstName, setFirstName] = useState(formState.firstName || '')
    const [lastNameKana, setLastNameKana] = useState(formState.lastNameKana || '')
    const [firstNameKana, setFirstNameKana] = useState(formState.firstNameKana || '')

    const [nameTouched, setNameTouched] = useState<NameFormTouched>({
        lastName: false,
        firstName: false,
        lastNameKana: false,
        firstNameKana: false,
    })

    const [nameErrors, setNameErrors] = useState<NameFormErrors>({
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
    })

    useEffect(() => {
        const formValues = {
            lastName,
            firstName,
            lastNameKana,
            firstNameKana,
        }
        const newErrors = validateForm(formValues, nameTouched)
        setNameErrors(newErrors)
    }, [lastName, firstName, lastNameKana, firstNameKana, nameTouched])

    const handleNameBlur = (fieldName: string) => {
        setNameTouched(prev => ({
            ...prev,
            [fieldName]: true,
        }))
    }

    const isFormValid = checkFormValidity({ lastName, firstName, lastNameKana, firstNameKana })

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='あなたのお名前は？'
                        dataViewLabel={dataViewLabel('EF_StepForm_お名前')}
                        dataClickLabel={dataClickLabel('EF_StepForm_お名前-戻る')}
                    />
                </div>

                <div className={styles.nameField}>
                    <NameFormField
                        fieldName="lastName"
                        fieldValue={lastName}
                        setFieldValue={setLastName}
                        label="姓"
                        placeholder="山田"
                        disabled={true}
                        nameErrors={nameErrors}
                        onBlur={handleNameBlur}
                    />
                    <NameFormField
                        fieldName="firstName"
                        fieldValue={firstName}
                        setFieldValue={setFirstName}
                        label="名"
                        placeholder="太郎"
                        disabled={true}
                        nameErrors={nameErrors}
                        onBlur={handleNameBlur}
                    />
                </div>

                <div className={styles.furiganaField}>
                    <NameFormField
                        fieldName="lastNameKana"
                        fieldValue={lastNameKana}
                        setFieldValue={setLastNameKana}
                        label="セイ"
                        placeholder="ヤマダ"
                        nameErrors={nameErrors}
                        onBlur={handleNameBlur}
                    />
                    <NameFormField
                        fieldName="firstNameKana"
                        fieldValue={firstNameKana}
                        setFieldValue={setFirstNameKana}
                        label="メイ"
                        placeholder="タロウ"
                        nameErrors={nameErrors}
                        onBlur={handleNameBlur}
                    />
                </div>

                <NextButton
                    formKey={['firstName', 'lastName', 'firstNameKana', 'lastNameKana']}
                    formValue={[firstName, lastName, firstNameKana, lastNameKana]}
                    displayFormKey={['name', 'nameKana']}
                    displayFormValue={[
                        `${lastName} ${firstName}`,
                        `${lastNameKana} ${firstNameKana}`,
                    ]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_お名前-次へ')}
                />
            </div>
        </div>
    )
}
